// extracted by mini-css-extract-plugin
module.exports = {"row":"grid_row__-2cDp","column":"grid_column__1VJbM"};